import { Segment } from "#app/(unauthorized)/authentication/segment";
import type { NavRoutesConfig } from "#app/_ui/components/headers/nav-routes-config";

import filterHelper from "./filterHelper";
import type { NavRoutesConfigFilterParams } from "./filterNav";

export default function preclientNavFilter({
  jwt,
  navRoutesConfig,
  requiredData,
}: NavRoutesConfigFilterParams): NavRoutesConfig {
  let filtering = filterHelper(navRoutesConfig);

  if (!requiredData.hasStartedOnboarding) {
    filtering = filtering.removeRouteSubById(
      "AccountServices",
      "AccountServicesOpenAccount",
    );
  }

  if (jwt.segment === Segment.Preclient) {
    filtering = filtering.removeRouteSubById(
      "AccountServices",
      "AccountServicesEbill",
    );
  }

  return filtering.getFilteredRoutesConfig();
}
